export const GET_CUSTOMERS_COMMENTS_REQUEST = 'GET_CUSTOMERS_COMMENTS_REQUEST';
export const GET_CUSTOMERS_COMMENTS_SUCCESS = 'GET_CUSTOMERS_COMMENTS_SUCCESS';
export const GET_CUSTOMERS_COMMENTS_FAILURE = 'GET_CUSTOMERS_COMMENTS_FAILURE';
